/**
 * Returns the configuration object provided by ./server.js via the script reference in index.html
 */
export default window.__RUNTIME_CONFIG__;
